var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"supplier-settings-subscription-tab"},[_c('div',{staticClass:"flex flex-col"},[_c('iframe-v4',{attrs:{"src":_vm.url,"height":3000}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }